export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const UI_DATE_FORMAT = 'DD-MM-YYYY';

export const PERIOD_FORMAT = {
  custom: 'L',
  day: 'L',
  week: 'WW/GGGG', // iso weeks default
  weekLocal: 'ww/gggg',
  month: 'MMM YYYY',
  quarter: 'Qo YYYY',
  year: 'YYYY'
};
